var map = {
	"./app-preview.png": "9e51",
	"./featured-preview.png": "10bd",
	"./features-preview.png": "0985",
	"./header-preview.png": "7440",
	"./news-preview.png": "9d4f",
	"./newsleft-preview.png": "59a0",
	"./post-preview.png": "154c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e060";